import React, { useMemo, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { toggleModalWithTimer, toggleSpinner } from 'apps/auth/actions/appAction';
import { KYC_FAILED_SCREEN, KYC_FAILED_VERIFYING_SCREEN, KYC_VERIFYING_SCREEN } from 'apps/auth/constants/ComponentNames';
import { PAYSEND_URL, SITE_PAYSEND, REACT_PAYSEND, LOCALHOST_CLIENT, KYC_LULU_AE_CONFIRM } from 'apps/auth/constants/UrlConstants';
import { sendingFieldsToServer, prepareValueForServer } from 'apps/auth/services/kycService';

const Iframe = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-width: 0;
`;
const STATUS_FAILURE = 'failure';
const LuluKycSDK = ({ luluKycEncodedHtml, setCurrentScreen, documentSubmitted, fields, kycRequestId }) => {
    const iframeRef = useRef(null);
    const dispatch = useDispatch();
    const cachedDecodedData = useMemo(() => window && luluKycEncodedHtml && window.atob(luluKycEncodedHtml), [luluKycEncodedHtml]);

    useEffect(() => {
        const failedFunc = (message = '') => {
            setCurrentScreen({
                screen: KYC_FAILED_SCREEN,
                message,
            });
        };
        const successFuncSdk = (json) => {
            if (json?.extra?.response === 'OK') {
                toggleModalWithTimer(
                    true,
                    documentSubmitted,
                )(dispatch).then(() => {
                    setCurrentScreen((prevScreen) => {
                        return {
                            ...prevScreen,
                            screen: KYC_VERIFYING_SCREEN,
                        };
                    });
                });
            } else {
                setCurrentScreen((prevScreen) => {
                    return {
                        ...prevScreen,
                        screen: KYC_FAILED_VERIFYING_SCREEN,
                    };
                });
            }
        };
        const onMessage = (event) => {
            const { data, origin } = event;
            const eventOrigin = origin === PAYSEND_URL || origin === SITE_PAYSEND || origin === REACT_PAYSEND || origin === LOCALHOST_CLIENT;
            if (eventOrigin && data?.confirmation_status) {
                const newFields = prepareValueForServer(fields, kycRequestId);
                sendingFieldsToServer(toggleSpinner, dispatch)(KYC_LULU_AE_CONFIRM, newFields, successFuncSdk, failedFunc);
            } else if (eventOrigin && (data?.status === STATUS_FAILURE || data?.data?.confirmation_status === false)) {
                const message = data?.message || data?.data?.rejection_message;
                failedFunc(message);
            }
        };
        if (__isBrowser__) {
            window.addEventListener('message', onMessage);
        }
        return () => {
            window.removeEventListener('message', onMessage);
        };
    }, [documentSubmitted, setCurrentScreen]);

    if (cachedDecodedData) {
        return <Iframe ref={iframeRef} title="lulu kyc" allow="camera" srcDoc={cachedDecodedData} />;
    }
    return null;
};
LuluKycSDK.propTypes = {
    luluKycEncodedHtml: PropTypes.string,
    setCurrentScreen: PropTypes.func,
    documentSubmitted: PropTypes.string,
    fields: PropTypes.object,
    kycRequestId: PropTypes.string,
};
export default LuluKycSDK;
